export const LINKS = {
  DEMO: 'woop-dev-link',
  PROD: '5922c462-e4bf-4f44-a78d-4b6a59d74eea',
  SANDBOX: 'woop-sandbox' /* Enables user_good, pass_good login */
};
